import SchoolSummary from './SchoolSummary';

export default SchoolSummary;
